<template>
  <button
    class="btn btn-tertiary btn-lg"
    :disabled="uploadInProgress"
    @click="onClick"
  >
    <translation :text="lang.get('buttons.cancel')" />
  </button>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  inject: ['lang'],
  computed: {
    visible() {
      return !this.hasExistingEntry || this.uploadInProgress;
    },
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isValid ||
        !this.isSaveable ||
        !this.isLoaded
      );
    },
    ...mapGetters('entryForm', ['hasMultipleTabs']),
    ...mapState('entryForm', ['uploadInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    ...mapActions('entryFormApi', { onClick: 'close' })
  }
};
</script>
